"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameScreen = void 0;
var react_1 = __importDefault(require("react"));
var StandardScene_1 = require("../../game/Scenes/StandardScene");
var ScoreState;
(function (ScoreState) {
    ScoreState[ScoreState["Default"] = 0] = "Default";
    ScoreState[ScoreState["Correct"] = 1] = "Correct";
    ScoreState[ScoreState["Incorrect"] = 2] = "Incorrect";
})(ScoreState || (ScoreState = {}));
var GameScreen = /** @class */ (function (_super) {
    __extends(GameScreen, _super);
    function GameScreen(props) {
        var _this = _super.call(this, props) || this;
        _this.prevScoreClass = "";
        _this.state = {
            score: _this.props.app.gameManager.getCurrentScore(),
            scoreState: ScoreState.Default,
            highScore: _this.props.app.gameManager.getScoreData().highestScore
        };
        _this.gameContainerRef = react_1.default.createRef();
        return _this;
    }
    GameScreen.prototype.componentDidMount = function () {
        this.props.app.startGame();
        var container = this.gameContainerRef.current;
        if (container) {
            this.scene = new StandardScene_1.StandardScene(container, container.offsetWidth, container.offsetHeight);
            this.scene.buildBoxesByRandomWord(this.props.app.currentWord());
        }
        this.animateBackgroundColour();
    };
    GameScreen.prototype.onTryWordClicked = function () {
        var combinedWord = this.scene.getCombinedWord();
        var correct = this.props.app.checkAnswer(combinedWord);
        if (correct === true) {
            this.scene.buildBoxesByRandomWord(this.props.app.currentWord());
        }
        this.setState({
            score: this.props.app.gameManager.getCurrentScore(),
            scoreState: correct == true ? ScoreState.Correct : ScoreState.Incorrect
        }, this.showFeedback.bind(this));
    };
    GameScreen.prototype.showFeedback = function () {
        switch (this.state.scoreState) {
            case ScoreState.Correct:
                break;
            case ScoreState.Incorrect:
                this.scene.shuffleBoxes();
                this.scene.slowMotionForSeconds(2);
                break;
        }
        this.animateScore();
    };
    GameScreen.prototype.animateScore = function () {
        var _this = this;
        this.animateBackgroundColour();
        setTimeout(function () {
            _this.setState({
                scoreState: ScoreState.Default
            });
        }, 2000);
    };
    GameScreen.prototype.animateBackgroundColour = function () {
        var screen = document.querySelector(".screen");
        if (screen.classList.contains(this.prevScoreClass)) {
            screen.classList.remove(this.prevScoreClass);
        }
        if (this.state.score > 5) {
            this.prevScoreClass = "background-level";
        }
        else {
            this.prevScoreClass = "background-level-" + this.state.score;
        }
        screen.classList.add(this.prevScoreClass);
    };
    GameScreen.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "game-container", ref: this.gameContainerRef }),
            react_1.default.createElement("div", { className: "content" },
                react_1.default.createElement("div", { className: "game-ui" },
                    react_1.default.createElement("div", { className: "answer-text" },
                        react_1.default.createElement("h1", { className: (ScoreState[this.state.scoreState].toLowerCase()) },
                            this.state.scoreState == ScoreState.Incorrect ? "Wrong!" : "",
                            this.state.scoreState == ScoreState.Correct ? "Correct!" : "")),
                    react_1.default.createElement("div", { className: "topic" },
                        react_1.default.createElement("p", null,
                            "Hint - ",
                            this.props.app.currentLevel().hint)),
                    react_1.default.createElement("div", { className: "score score-" + (ScoreState[this.state.scoreState].toLowerCase()) },
                        react_1.default.createElement("p", { className: "current-score" }, this.state.score),
                        react_1.default.createElement("small", { className: "best-score" },
                            "Best ",
                            this.state.highScore))),
                react_1.default.createElement("button", { className: "btn btn-primary btn-block text-uppercase ", onClick: this.onTryWordClicked.bind(this) }, "Try Word"))));
    };
    return GameScreen;
}(react_1.default.Component));
exports.GameScreen = GameScreen;
